<template>
  <div>
    <v-card>
      <v-card-title>
        {{ $t('Обратная связь') }}
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="10"
            cols="12"
          >
            <h2 class="text-2xl font-weight-semibold text--primary">
              {{ $t('Мы всегда рады услышать вас!') }}
            </h2>
            <p class="text-sm pt-6 pb-4">
              {{ $t('Наши усилия направлены на то, чтобы сделать систему подачи заявок максимально удобной и эффективной для вас. Ваше мнение и предложения играют ключевую роль в этом процессе. Не стесняйтесь делиться своими мыслями, идеями, а также сообщать нам обо всех замеченных ошибках или проблемах в работе системы. Вместе мы сделаем систему подачи заявок лучше!') }}
            </p>
          </v-col>
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="10"
            cols="12"
          >
            <v-text-field
              v-model="feedback.name"
              :label="$t('Как к вам обращаться?')"
              dense
              outlined
              hide-details
            ></v-text-field>
          </v-col>
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="10"
            cols="12"
          >
            <v-text-field
              v-model="feedback.email"
              :label="$t('Email для обратной связи')"
              dense
              outlined
              :rules="[emailRule]"
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="10"
            cols="12"
          >
            <v-textarea
              id="textarea-feedback-text"
              v-model="feedback.text"
              :label="$t('Опишите ваше предложение, жалобу или замеченную ошибку')"
              outlined
              auto-grow
              class="mt-2"
              rows="4"
              :error-messages="textError"
              @input="textError = ''"
            ></v-textarea>
          </v-col>
          <!-- Кнопки действий держим справа — единое правило по всему кабинету. -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="10"
            cols="12"
            class="d-flex justify-end"
          >
            <v-btn
              color="primary"
              :loading="isSending"
              @click="sendFeedback"
            >
              {{ $t('Отправить') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="showResult"
      width="480"
    >
      <v-card class="pa-2">
        <v-card-title class="text-h5 font-weight-bold text--primary">
          {{ resultOk ? $t('Спасибо!') : $t('Не отправилось') }}
        </v-card-title>
        <v-card-text class="text--primary text-base">
          <template v-if="resultOk">
            {{ $t('Мы получили ваше обращение и обязательно его прочитаем. Если нужен ответ — напишем на указанную почту.') }}
          </template>
          <template v-else>
            {{ $t('Что-то пошло не так на нашей стороне. Текст остался в форме — попробуйте отправить ещё раз через минуту.') }}
          </template>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            :color="resultOk ? 'primary' : 'error'"
            large
            @click="showResult = false"
          >
            {{ $t('Ок') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import store from '@/store'

export default {
  setup() {
    const feedback = ref({ text: '', name: '', email: '' })
    const textError = ref('')
    const showResult = ref(false)
    const resultOk = ref(false)

    // Имя и почту подставляем из аккаунта — человек уже вошёл, печатать свои
    // же данные незачем. Поправить можно прямо в форме.
    store.dispatch('support/fetchPrefill').then(data => {
      feedback.value.name = feedback.value.name || (data && data.name) || ''
      feedback.value.email = feedback.value.email || (data && data.email) || ''
    })

    const emailRule = value => {
      const text = String(value || '').trim()
      if (!text) return true

      return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(text) || 'Проверьте адрес почты'
    }

    const sendFeedback = () => {
      const text = String(feedback.value.text || '').trim()
      if (!text) {
        textError.value = 'Напишите, что хотите нам сообщить'

        return
      }
      if (emailRule(feedback.value.email) !== true) return

      store
        .dispatch('support/submit', {
          name: feedback.value.name,
          email: feedback.value.email,
          text,
        })
        .then(ok => {
          resultOk.value = ok
          showResult.value = true

          // Текст очищаем только если обращение приняли: иначе человек
          // потеряет написанное и второй раз писать не станет.
          if (ok) feedback.value.text = ''
        })
    }

    return {
      feedback,
      textError,
      emailRule,
      sendFeedback,
      showResult,
      resultOk,
      isSending: computed(() => store.getters['support/isSending']),
    }
  },
}
</script>

  <style lang="scss">
    @import '@core/preset/preset/misc.scss';
  </style>
